export const cancelRequestedSelector = state =>
  state.bulkDeleteBusiness.process.cancelRequested;
